import React, { useContext, forwardRef } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import AccordionContext from '../Accordion/AccordionContext'
import './accordion-header.scss'
import { Icon } from '../../index'

const AccordionHeader = forwardRef(function AccordionHeader(props, ref) {
	const { arrowSize = 1, component: Component = 'div', children, className, invertedArrows, onClick, showArrow, arrowProps, onlyArrowExpand, ...other } = props

	const { disabled = false, expanded, toggle, isControlled } = useContext(AccordionContext)

	const handleChange = (event) => {
		toggle(event)
		typeof onClick === 'function' && onClick(event)
	}

	return (
		<Component
			className={clsx(
				'Vb-accordion__header',
				disabled && 'Vb-accordion__header--disabled',
				!onlyArrowExpand && !isControlled && 'Vb-accordion__header--click',
				className
			)}
			aria-expanded={expanded}
			onClick={!onlyArrowExpand && !disabled ? handleChange : null}
			ref={ref}
			{...other}
		>
			<div className={'Vb-accordion__header__content'}>
				{children}
			</div>

			{(showArrow || onlyArrowExpand) && (
				<div className="Vb-accordion__arrow" onClick={onlyArrowExpand && !disabled ? handleChange : null} {...arrowProps}>
					{invertedArrows ? (
						<Icon size={arrowSize} color={disabled ? 'gray-3' : 'primary-lima'}>
							{expanded ? 'arrow-down' : 'arrow-up'}
						</Icon>
					) : (
						<Icon size={arrowSize} color={disabled ? 'gray-3' : 'primary-lima'}>
							{expanded ? 'arrow-up' : 'arrow-down'}
						</Icon>
					)}
				</div>
			)}
		</Component>
	)
})

export default AccordionHeader

AccordionHeader.defaultProps = {
	arrowSize: 1,
	component: 'div'
}

AccordionHeader.propTypes = {
	/**
	 * Size value of the arrow icon in rem.
	 * @default 1
	 */
	arrowSize: PropTypes.number,
	/**
	 * The content of the component.
	 */
	children: PropTypes.node,
	/**
	 * @ignore
	 */
	className: PropTypes.string,
	/**
	 * The component used for the root node.
	 * Either a string to use a HTML element or a component.
	 * @default 'div'
	 */
	component: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.node]),
	/**
	 * If true, arrows directions are inverted. Usefull when module is at the bottom of the screen.
	 */
	invertedArrows: PropTypes.bool,
	/**
	 * If true, shows a dropdown-style UI arrow
	 */
	showArrow: PropTypes.bool,
	/**
	 * If true, only the arrow symbols will be clickable and interactive.
	 * If false, all the Accordion Header will.
	 * Setting it true bypasses prop `showArrow` false state.
	 */
	onlyArrowExpand: PropTypes.bool,
	/**
	 * @ignore
	 */
	onClick: PropTypes.func
}
